<script setup lang="ts">
import type { Component } from 'vue';
import { DropdownMenuSubTrigger } from 'reka-ui';

withDefaults(
    defineProps<{
        label?: string;
        icon?: Component;
        disabled?: boolean;
    }>(),
    {
        disabled: false,
    },
);
</script>

<template>
    <DropdownMenuSubTrigger
        :disabled="disabled"
        class="flex cursor-pointer items-center rounded px-3 py-2 text-sm text-muval-gray-1 outline-none transition-colors hover:bg-muval-gray-6 data-[highlighted]:bg-muval-gray-6"
    >
        <component
            :is="icon"
            v-if="icon"
            class="mr-2 size-5 shrink-0 text-muval-gray-2"
        />
        <span
            v-if="label"
            class="flex-1 truncate"
            >{{ label }}</span
        >
        <slot v-else />
        <SvgIcon
            name="system-chevron-right"
            class="ml-auto size-4 text-muval-gray-3"
        />
    </DropdownMenuSubTrigger>
</template>
